import INVOICE_REPORTS from "../graphql/reportsInvoices.gql";
import ORDER_REPORTS from "../graphql/reportsOrders.gql";
import CUSTOMER_REPORT from "../graphql/reportCustomerBalance.gql";
import INVOICE_PDF from "../graphql/reportInvoicePdf.gql";
import ORDER_PDF from "../graphql/reportOrderPdf.gql";
import { apolloClient } from "./apollo";

/**
 * This is only mock api
 *
 */
export function getOrdersByCustomer(cardCode) {
    if(!window.navigator.onLine)
        return '';
    return apolloClient.mutate({
        mutation: ORDER_REPORTS,
        variables: {
            cardCode: cardCode
        }
    })
}
export function getInvoicesByCustomer(cardCode) {
    if(!window.navigator.onLine)
        return '';
    return apolloClient.mutate({
        mutation: INVOICE_REPORTS,
        variables: {
            cardCode: cardCode
        }
    })
}
export function getBalanceByCustomer(cardCode){
    if(!window.navigator.onLine)
        return '';
    return apolloClient.mutate({
        mutation: CUSTOMER_REPORT,
        fetchPolicy: "no-cache",
        variables: {
            cardCode: cardCode
        }
    })
}
export function getInvoicePdf(invoice){
    if(!window.navigator.onLine)
        return '';
    return apolloClient.mutate({
        mutation: INVOICE_PDF,
        fetchPolicy: "no-cache",
        variables: {
            docNum: invoice.docNum,
            docEntry: invoice.docEntry
        }
    })
}
export function getOrderPdf(order){
    if(!window.navigator.onLine)
        return '';
    return apolloClient.mutate({
        mutation: ORDER_PDF,
        fetchPolicy: "no-cache",
        variables: {
            docNum: order.docNum,
            docEntry: order.docEntry
        }
    })
}

